export default {
	agent_gateway_auth_required: 'Please sign in again.',
	agent_gateway_instance_database_not_configured: 'No agent gateway storage is configured for this instance.',
	agent_gateway_invalid_memory_input: 'Please check the memory values.',
	agent_gateway_invalid_provider_input: 'Please check the provider values.',
	agent_gateway_memory_conflict: 'The memory page has changed in the meantime.',
	agent_gateway_memory_forbidden: 'You do not have the rights required for this memory action.',
	agent_gateway_memory_not_found: 'The memory page was not found.',
	agent_gateway_provider_base_url_rejected: 'The provider URL is not allowed for security reasons.',
	agent_gateway_provider_capability_unsupported: 'The provider does not support this agent request.',
	agent_gateway_provider_conflict: 'A provider with this name already exists.',
	agent_gateway_provider_explorer_structured_output_unsupported: 'The Explorer requires structured output.',
	agent_gateway_provider_explorer_tool_use_unsupported: 'The Explorer requires tool use.',
	agent_gateway_provider_forbidden: 'You do not have the rights required for this provider action.',
	agent_gateway_provider_memory_metadata_frontier_denied: 'Memory metadata may not be sent to frontier providers.',
	agent_gateway_provider_memory_requires_exact_local:
		'This memory request requires a local provider without fallback.',
	agent_gateway_provider_memory_summary_frontier_denied: 'Memory summaries may not be sent to frontier providers.',
	agent_gateway_provider_not_found: 'The provider was not found.',
	agent_gateway_provider_preparer_structured_output_unsupported: 'The Preparer requires structured output.',
	agent_gateway_provider_structured_output_unsupported: 'The provider does not support structured output.',
	agent_gateway_provider_tier_conflict: 'The tier assignment is ambiguous.',
	agent_gateway_provider_tier_frontier_duplicate: 'More than one active frontier provider exists.',
	agent_gateway_provider_tier_frontier_unavailable: 'No frontier provider is available.',
	agent_gateway_provider_tier_local_duplicate: 'More than one active local provider exists.',
	agent_gateway_provider_tier_local_unavailable: 'No local provider is available.',
	agent_gateway_provider_tier_unavailable: 'No provider is available for this tier.',
	agent_gateway_unknown_error: 'The agent gateway could not process the request.',
	mail_rules_auto_delegate_empty_caption: 'Create a new delegation rule using the button in the top right.',
	mail_rules_auto_delegate_empty_title: 'No delegation rules found',
	mail_rules_blacklist_empty_caption: 'Addresses can be added to the blacklist directly from an email.',
	mail_rules_blacklist_empty_title: 'Blacklist is empty',
	mail_rules_no_archive_empty_caption: 'Add an address using the button in the top right.',
	mail_rules_no_archive_empty_title: 'No hidden addresses found',
	mail_rules_remove_spam_empty_caption: 'Entries are created when you remove the spam mark from an email.',
	mail_rules_remove_spam_empty_title: 'No rules found',
	mail_rules_spam_empty_caption: 'Create a new rule using the button in the top right.',
	mail_rules_spam_empty_title: 'No spam rules found',
	oauth_authorize_invalid_request_error: 'The authorization request is invalid. Check the link and try again.',
	oauth_authorize_loading: 'Checking authorization request...',
	oauth_authorize_login_required_error: 'Authentication is required for this request. Sign in again and retry.',
	oauth_authorize_redirect_error: 'The authorization endpoint returned an unexpected redirect. Please try again.',
	oauth_authorize_retry_button: 'Try again',
	oauth_authorize_temporarily_unavailable_error:
		'The authorization service is temporarily unavailable. Please try again shortly.',
	oauth_authorize_title: 'Authorize application access',
	oauth_authorize_unknown_error:
		'The authorization request could not be completed. Check your connection and try again.',
	oauth_consent_approve_button: 'Allow access',
	oauth_consent_client_label: 'Application',
	oauth_consent_client_unverified: 'unverified name',
	oauth_consent_deny_button: 'Deny',
	oauth_consent_description: '{clientName} is requesting access to this instance.',
	oauth_consent_ineligible_message:
		'OAuth/MCP access is not enabled for your user on this instance; ask your administrator.',
	oauth_consent_load_error: 'The access request could not be loaded. Check the link and try again.',
	oauth_consent_loading: 'Loading access request...',
	oauth_consent_redirect_label: 'Reply goes to',
	oauth_consent_redirect_unknown: 'unknown — this instance does not report the reply target yet',
	oauth_consent_resource_label: 'MCP resource',
	oauth_consent_retry_button: 'Try again',
	oauth_consent_submit_error: 'Your decision could not be submitted. Please try again.',
	oauth_consent_title: 'Approve MCP/API access',
	oauth_instance_invalid_error: 'The specified instance is invalid. Check the link and try again.',
	oauth_instance_unknown_error:
		'The specified instance could not be found or reached. Check the instance name and try again.',
	setting_user_online_list_view_mode_compressed_label: 'Compressed view',
	setting_user_online_list_view_mode_large_label: 'Large view',
	settings_about_city: '59557 Lippstadt',
	settings_about_close_button_label: 'OK',
	settings_about_company_name: 'NETZkultur Informationssysteme GmbH',
	settings_about_court: 'Paderborn District Court',
	settings_about_email_label: 'Email: ',
	settings_about_email_value: 'kontakt@netzkultur.de',
	settings_about_managing_director: 'Managing Director: Ino Holling',
	settings_about_office_hours: 'Office hours: Monday to Friday from 8:00 a.m. to 5:30 p.m.',
	settings_about_phone_label: 'Phone: ',
	settings_about_phone_value: '+49 29 41 - 27 263 - 0',
	settings_about_privacy_label: 'Privacy policy',
	settings_about_section_description: 'Version details, notes and background information about the app.',
	settings_about_street: 'Hansastr. 23',
	settings_about_tab: 'About',
	settings_about_tax_id: 'VAT ID No.: DE233203591',
	settings_about_terms_label: 'Our general terms and conditions',
	settings_about_trade_register: 'Commercial register: HRB 6334',
	settings_about_website_label: 'Website: ',
	settings_about_website_value: 'www.netzkultur.de',
	settings_agent_memory_archive_label: 'Archive',
	settings_agent_memory_backlinks_label: 'Backlinks',
	settings_agent_memory_context_layer_label: 'Context layer',
	settings_agent_memory_delete_label: 'Delete',
	settings_agent_memory_description: 'Manage private markdown memory pages for the agent.',
	settings_agent_memory_empty_hint: 'Create a private memory page or search existing pages.',
	settings_agent_memory_empty_title: 'No memory pages found',
	settings_agent_memory_error_generic: 'The memory pages could not be processed.',
	settings_agent_memory_group_title: 'Memory',
	settings_agent_memory_include_archived_label: 'Include archived pages',
	settings_agent_memory_link_broken: 'Broken link',
	settings_agent_memory_links_label: 'Links',
	settings_agent_memory_markdown_label: 'Markdown',
	settings_agent_memory_new_label: 'New',
	settings_agent_memory_path_label: 'Path',
	settings_agent_memory_portable_category_label: 'Portable category',
	settings_agent_memory_preview_label: 'Preview',
	settings_agent_memory_privacy_state_label: 'Privacy review state',
	settings_agent_memory_refresh_label: 'Refresh',
	settings_agent_memory_save_label: 'Save',
	settings_agent_memory_save_success: 'Memory page saved.',
	settings_agent_memory_search_label: 'Search',
	settings_agent_memory_section_description: 'Search, edit, and archive private memory pages.',
	settings_agent_memory_status_active: 'Active',
	settings_agent_memory_status_archived: 'Archived',
	settings_agent_memory_tab: 'Agent — Memory',
	settings_agent_memory_tags_label: 'Tags (comma separated)',
	settings_agent_memory_title_label: 'Title',
	settings_agent_memory_unarchive_label: 'Restore',
	settings_agent_provider_api_key_keep_hint: 'Leave empty to keep the stored key.',
	settings_agent_provider_api_key_label: 'API key',
	settings_agent_provider_api_key_new_hint: 'The key is stored only on the server.',
	settings_agent_provider_archive_cancel_label: 'Cancel',
	settings_agent_provider_archive_confirm_label: 'Archive',
	settings_agent_provider_archive_confirm_message: 'Archive this provider?',
	settings_agent_provider_archive_confirm_title: 'Archive provider',
	settings_agent_provider_archive_label: 'Archive',
	settings_agent_provider_archive_success: 'Provider archived.',
	settings_agent_provider_base_url_label: 'Base URL',
	settings_agent_provider_capability_structured_output: 'Structured output',
	settings_agent_provider_capability_tool_use: 'Tool use',
	settings_agent_provider_context_window_hint: 'Optional. Used to derive the message budget automatically.',
	settings_agent_provider_context_window_label: 'Context window (tokens)',
	settings_agent_provider_default_model_hint:
		'Models are loaded from the saved provider; free input is still possible.',
	settings_agent_provider_default_model_label: 'Default model',
	settings_agent_provider_display_name_label: 'Name',
	settings_agent_provider_empty_hint: 'Create a personal or instance-wide provider.',
	settings_agent_provider_empty_title: 'No providers found',
	settings_agent_provider_enabled_label: 'Provider enabled',
	settings_agent_provider_error_generic: 'The providers could not be processed.',
	settings_agent_provider_grants_description: 'Select the users who may use this instance-managed provider.',
	settings_agent_provider_grants_no_users: 'No users found',
	settings_agent_provider_grants_save_label: 'Save grants',
	settings_agent_provider_grants_save_success: 'Provider grants saved.',
	settings_agent_provider_grants_title: 'User grants',
	settings_agent_provider_grants_users_label: 'Granted users',
	settings_agent_provider_message_limit_hint:
		'Optional. Overrides the automatically derived limit per provider message.',
	settings_agent_provider_message_limit_label: 'Message limit (characters)',
	settings_agent_provider_new_label: 'New',
	settings_agent_provider_no_default_model: 'No default model',
	settings_agent_provider_refresh_label: 'Refresh',
	settings_agent_provider_save_label: 'Save',
	settings_agent_provider_save_success: 'Provider saved.',
	settings_agent_provider_scope_instance_managed: 'Instance',
	settings_agent_provider_scope_label: 'Scope',
	settings_agent_provider_scope_user_owned: 'Personal provider',
	settings_agent_provider_test_failed: 'Connection failed',
	settings_agent_provider_test_invalid: 'Credentials invalid',
	settings_agent_provider_test_label: 'Test connection',
	settings_agent_provider_test_valid: 'Connection successful',
	settings_agent_provider_tier_alias_frontier: 'Frontier',
	settings_agent_provider_tier_alias_label: 'Tier',
	settings_agent_provider_tier_alias_local: 'Local',
	settings_agent_provider_tier_alias_none: 'No tier',
	settings_agent_provider_type_anthropic: 'Anthropic',
	settings_agent_provider_type_grok: 'Grok',
	settings_agent_provider_type_label: 'Provider type',
	settings_agent_provider_type_openai: 'OpenAI',
	settings_agent_provider_type_openai_compatible: 'OpenAI-compatible',
	settings_agent_provider_validation_failed: 'Failed',
	settings_agent_provider_validation_invalid: 'Invalid',
	settings_agent_provider_validation_unknown: 'Unchecked',
	settings_agent_provider_validation_valid: 'Valid',
	settings_agent_providers_description: 'Configure providers for agents. API keys are never returned to the app.',
	settings_agent_providers_group_title: 'Providers',
	settings_agent_providers_section_description: 'Manage OpenAI, Grok, OpenAI-compatible providers and Anthropic.',
	settings_agent_providers_tab: 'Agent — Providers',
	settings_app_icon: 'App Icon',
	settings_app_icon_description: 'Which icon would you like to use for the app?',
	settings_app_icon_restore_default: 'Restore to Original',
	settings_app_icon_section_description: 'Choose and reset the iOS home screen app icon.',
	settings_behaviour_finished_back_to_list_toggle_caption: 'Finishing an entry returns the app to its list.',
	settings_behaviour_finished_back_to_list_toggle_label: 'Jump back to the list after finishing',
	settings_behaviour_group_workflow: 'Workflow',
	settings_behaviour_section_description: 'How the app reacts to your actions.',
	settings_behaviour_show_split_view_toggle_caption: 'Opened entries appear next to the list instead of full width.',
	settings_behaviour_show_split_view_toggle_label: 'Open entries in the side panel',
	settings_behaviour_splitview_warning_accept: 'Continue',
	settings_behaviour_splitview_warning_message:
		'Switching closes any open detail panes. Unsaved changes will be lost.',
	settings_behaviour_splitview_warning_title: 'Switch side panel?',
	settings_behaviour_tab: 'Behavior',
	settings_calendar_appointment_types_active_label: 'Active',
	settings_calendar_appointment_types_add_participant_label: 'Add user or group',
	settings_calendar_appointment_types_alert_unit_label: 'Alert unit',
	settings_calendar_appointment_types_alert_value_label: 'Alert lead time',
	settings_calendar_appointment_types_color_label: 'Color',
	settings_calendar_appointment_types_delete_cancel_label: 'Cancel',
	settings_calendar_appointment_types_delete_confirm_label: 'Delete',
	settings_calendar_appointment_types_delete_label: 'Delete',
	settings_calendar_appointment_types_delete_message: 'Do you really want to delete this appointment type?',
	settings_calendar_appointment_types_delete_title: 'Delete appointment type',
	settings_calendar_appointment_types_description:
		'Manage appointment types including active and global flags, colors, participants, permissions and Ido links.',
	settings_calendar_appointment_types_description_label: 'Description',
	settings_calendar_appointment_types_duration_hours_label: 'Duration hours',
	settings_calendar_appointment_types_duration_minutes_label: 'Duration minutes',
	settings_calendar_appointment_types_empty_label: 'Select an appointment type on the left or create a new one.',
	settings_calendar_appointment_types_global_label: 'Global',
	settings_calendar_appointment_types_group_title: 'Appointment types',
	settings_calendar_appointment_types_ido_label: 'Files',
	settings_calendar_appointment_types_load_error: 'The appointment types could not be loaded.',
	settings_calendar_appointment_types_new_label: 'New',
	settings_calendar_appointment_types_participants_label: 'Participants and permissions',
	settings_calendar_appointment_types_remove_participant_label: 'Remove',
	settings_calendar_appointment_types_save_label: 'Save',
	settings_calendar_appointment_types_section_description:
		'Edit appointment types, defaults, permissions and personal colors.',
	settings_calendar_appointment_types_start_hour_label: 'Start hour',
	settings_calendar_appointment_types_start_minute_label: 'Start minute',
	settings_calendar_appointment_types_tab: 'Appointment Types',
	settings_calendar_appointment_types_title_label: 'Title',
	settings_calendar_export_active_appointments_label: 'Active appointments',
	settings_calendar_export_add_subscription_label: 'Add calendar',
	settings_calendar_export_appointment_type_all_label: 'All appointment types',
	settings_calendar_export_appointment_type_label: 'Appointment type',
	settings_calendar_export_appointment_type_none_label: 'No appointment type',
	settings_calendar_export_copy_link_error: 'The iCal link could not be copied to the clipboard.',
	settings_calendar_export_copy_link_label: 'Copy link',
	settings_calendar_export_copy_link_success: 'The iCal link was copied to the clipboard.',
	settings_calendar_export_description:
		'Add the calendar directly, create an iCal link, or download an ICS export for the selected time range.',
	settings_calendar_export_download_label: 'Download',
	settings_calendar_export_end_date_before_start_error: 'The end date must not be before the start date.',
	settings_calendar_export_end_date_label: 'End date',
	settings_calendar_export_export_button_label: 'Start export',
	settings_calendar_export_export_type_ical_label: 'iCal Link',
	settings_calendar_export_export_type_label: 'Export type',
	settings_calendar_export_export_type_webcal_label: 'Calendar subscription',
	settings_calendar_export_group_result: 'Result',
	settings_calendar_export_group_title: 'Export calendar',
	settings_calendar_export_ical_link_label: 'iCal Link',
	settings_calendar_export_informative_appointments_label: 'Informative appointments',
	settings_calendar_export_privacy_keep_label: 'Keep privacy',
	settings_calendar_export_privacy_label: 'Privacy',
	settings_calendar_export_privacy_public_label: 'Convert all to public',
	settings_calendar_export_result_hint: 'Use the link in external calendars as a subscribable calendar source.',
	settings_calendar_export_section_description: 'Export calendars as ICS files or generate iCal subscription links.',
	settings_calendar_export_start_date_error: 'Please select a start date.',
	settings_calendar_export_start_date_label: 'Start date',
	settings_calendar_export_tab: 'Export',
	settings_calendar_export_unavailable_error: 'Calendar export is currently unavailable.',
	settings_calendar_general_description:
		'Only the calendar views that currently affect the app are stored for the shared calendar settings.',
	settings_calendar_general_group_title: 'Calendar view',
	settings_calendar_general_section_description:
		'Choose the default start view and the visible calendar views used in the app.',
	settings_calendar_general_start_view_label: 'Start view',
	settings_calendar_general_tab: 'View',
	settings_calendar_general_visible_views_label: 'Visible views',
	settings_calendar_settings_save_error: 'The calendar setting could not be saved.',
	settings_calendar_sharing_allow_toggle_label: 'Allow insight',
	settings_calendar_sharing_allowed_caption: 'This user may inspect your calendar.',
	settings_calendar_sharing_blocked_caption: 'This user is blocked from calendar insight.',
	settings_calendar_sharing_description:
		'Control which users may inspect your calendar. Changes are stored immediately.',
	settings_calendar_sharing_group_title: 'Sharing',
	settings_calendar_sharing_loading_label: 'Loading calendar sharing settings...',
	settings_calendar_sharing_section_description: 'Manage insight permissions for your calendar.',
	settings_calendar_sharing_tab: 'Sharing',
	settings_category_account_description: 'Profile, instances, profile picture and time zone.',
	settings_category_account_label: 'Account',
	settings_category_advanced_description: 'User groups, presence and dashboard.',
	settings_category_advanced_label: 'Advanced',
	settings_category_agent_description: 'Providers, memory and agent configuration.',
	settings_category_agent_label: 'Agent',
	settings_category_appearance_description: 'Theme, colors and visual language.',
	settings_category_appearance_label: 'Appearance',
	settings_category_calendar_description: 'Calendar view, appointment types, sharing and export.',
	settings_category_calendar_label: 'Calendar',
	settings_category_general_description: 'User, notifications, places and appearance.',
	settings_category_general_label: 'General',
	settings_category_mail_description: 'Email rules, filters and automatic forwarding.',
	settings_category_mail_label: 'Mail',
	settings_category_notifications_description: 'Push, alerts and notification channels.',
	settings_category_notifications_label: 'Notifications',
	settings_category_phone_description: 'Dial assistant and call lists.',
	settings_category_phone_label: 'Phone',
	settings_category_shortcuts_description: 'Keyboard shortcuts for navigation, actions and editor.',
	settings_category_shortcuts_label: 'Shortcuts',
	settings_category_support_description: 'Help, orientation and product information.',
	settings_category_support_label: 'Help & Info',
	settings_category_workspace_description: 'Layout, menus, lists, widgets and behavior.',
	settings_category_workspace_label: 'Workspace',
	settings_common_avatar_delete_dialog_confirm_cancel_label: 'No',
	settings_common_avatar_delete_dialog_confirm_message: 'Do you really want to delete the profile picture?',
	settings_common_avatar_delete_dialog_confirm_ok_label: 'Yes',
	settings_common_avatar_delete_dialog_confirm_title: 'Delete profile picture?',
	settings_common_avatar_description: 'Profile picture for the selected instance',
	settings_common_change_password_button_label: 'Change password',
	settings_common_change_password_cancel_label: 'Cancel',
	settings_common_change_password_confirmation_label: 'Repeat new password',
	settings_common_change_password_current_label: 'Current password',
	settings_common_change_password_dialog_title: 'Change password',
	settings_common_change_password_error_confirmation_mismatch: 'The confirmation does not match the new password.',
	settings_common_change_password_error_current_required: 'Please enter your current password.',
	settings_common_change_password_error_new_too_long: 'The new password must be at most {maxLength} characters long.',
	settings_common_change_password_error_new_too_short:
		'The new password must be at least {minLength} characters long.',
	settings_common_change_password_error_request_failed: 'The password could not be changed. Please try again.',
	settings_common_change_password_error_wrong_current: 'The current password is incorrect.',
	settings_common_change_password_new_label: 'New password',
	settings_common_change_password_submit_label: 'Save password',
	settings_common_change_password_success: 'Your password has been changed.',
	settings_common_configured_instances_description: 'Your configured instances',
	settings_common_delete_avatar_button_label: 'Delete profile picture',
	settings_common_group_account_actions: 'Account Actions',
	settings_common_group_instances: 'Instances',
	settings_common_group_language_region: 'Language & Region',
	settings_common_group_profile: 'Profile',
	settings_common_instance_active_label: 'Active',

	settings_common_instance_description: 'Here you can select and configure your infra-struktur instance(s).',
	settings_common_profile_loading: 'Loading profile...',
	settings_common_section_description: 'Manage profile, instances, profile picture and core account settings.',
	settings_common_tab: 'User',
	settings_common_update_avatar_button_label: 'Replace profile picture',
	settings_common_update_avatar_dialog_camera: 'Create with the camera',
	settings_common_update_avatar_dialog_cancel: 'Cancel',
	settings_common_update_avatar_dialog_create_new_avatar: 'Change profile picture',
	settings_common_update_avatar_dialog_create_new_avatar_source: 'Here you can choose a new profile picture',
	settings_common_update_avatar_dialog_mediathek: 'Select from photo library',
	settings_common_update_avatar_dialog_select_files: 'Select from file system',
	settings_common_update_avatar_dialog_selected_files: 'Selected file',
	settings_common_update_avatar_dialog_upload_error: 'The profile picture could not be uploaded.',
	settings_common_update_avatar_dialog_upload_files: 'Upload profile picture',
	settings_common_update_avatar_dialog_uploading: 'Uploading …',
	settings_controls: 'Control in list elements',
	settings_controls_context_menu: 'context menu',
	settings_controls_swipe_menu: 'Swipe',
	settings_controls_tab: 'Control in lists',
	settings_daily_activity_section_description: 'Review the activity for the selected day.',
	settings_daily_activity_tab: 'Daily Actions',
	settings_dashboard_diagnosis_alarm_center_text: 'The alarm center is currently not active.',
	settings_dashboard_diagnosis_alarm_center_title: 'Alarm center disabled',
	settings_dashboard_diagnosis_empty_text: 'No diagnostic information is available right now.',
	settings_dashboard_diagnosis_mailparser_text: 'The mail parser reports processing problems.',
	settings_dashboard_diagnosis_mailparser_title: 'Mail parser issue',
	settings_dashboard_diagnosis_no_details: 'No further details available.',
	settings_dashboard_diagnosis_signature_text: 'At least one mailbox is missing a default signature.',
	settings_dashboard_diagnosis_signature_title: 'Missing default signatures',
	settings_dashboard_diagnosis_standard_postbox_text: 'No default mailbox is configured.',
	settings_dashboard_diagnosis_standard_postbox_title: 'Default mailbox missing',
	settings_dashboard_diagnosis_success_text:
		'The most important legacy dashboard checks currently show no visible warnings.',
	settings_dashboard_diagnosis_success_title: 'No open diagnostic warnings',
	settings_dashboard_diagnosis_title: 'Diagnostics & hints',
	settings_dashboard_diagnosis_too_many_text: 'Too many elements are currently shown on the welcome area.',
	settings_dashboard_diagnosis_too_many_title: 'Too many elements',
	settings_dashboard_empty_text: 'Data will appear here once it is available or can be loaded.',
	settings_dashboard_empty_title: 'No data yet',
	settings_dashboard_eyebrow: 'Legacy dashboard',
	settings_dashboard_metric_active_users: 'Active users',
	settings_dashboard_metric_inactive_users: 'Inactive users',
	settings_dashboard_metric_incoming_mails: 'Incoming mail',
	settings_dashboard_metric_outgoing_mails: 'Outgoing mail',
	settings_dashboard_metric_red_calls: 'Red calls',
	settings_dashboard_metric_red_mails: 'Red mails',
	settings_dashboard_metric_virtual_users: 'Virtual users',
	settings_dashboard_module_activity: 'Activities',
	settings_dashboard_module_calls: 'Calls',
	settings_dashboard_module_documents: 'Documents',
	settings_dashboard_module_emails: 'Emails',
	settings_dashboard_module_messages: 'Messages',
	settings_dashboard_module_notes: 'Notes',
	settings_dashboard_module_tasks: 'Tasks',
	settings_dashboard_module_totals: 'Total',
	settings_dashboard_moment_empty_text: 'No values are available yet for the current activity distribution.',
	settings_dashboard_moment_title: 'Current distribution',
	settings_dashboard_overview_description:
		'A modern, responsive view of the legacy dashboard statistics for activity, system status and hints.',
	settings_dashboard_overview_title: 'Workspace and system health dashboard',
	settings_dashboard_partial_error_title: 'Some dashboard areas could not be loaded.',
	settings_dashboard_performance_empty_text: 'No performance ranking is available right now.',
	settings_dashboard_performance_title: 'Performance ranking',
	settings_dashboard_period_empty_text: 'No values are available yet for the activity trend of recent days.',
	settings_dashboard_period_title: 'Recent activity trend',
	settings_dashboard_refresh: 'Refresh',
	settings_dashboard_section_description:
		'Review statistics, diagnostic hints and system metrics from the legacy dashboard.',
	settings_dashboard_system_forbidden_text: 'System metrics are only visible for authorized users.',
	settings_dashboard_system_forbidden_title: 'System information restricted',
	settings_dashboard_system_title: 'System information',
	settings_dashboard_tab: 'Dashboard',
	settings_dateformat_caption: 'How dates are displayed throughout the app',
	settings_dateformat_label: 'Date format',
	settings_group_active: 'Active',
	settings_group_create: 'Create',
	settings_group_delete: 'Delete',
	settings_group_description: 'Here you can create and edit user groups!',
	settings_group_empty_hint: 'Please select a group',
	settings_group_globalRight_activated: 'Shared group from %name%',
	settings_group_globalRight_deactivated: 'Share group with all users',
	settings_group_members: 'Group members',
	settings_group_members_empty: 'Add members from the list on the right',
	settings_group_name: 'Name:',
	settings_group_save: 'Save',
	settings_group_settings: 'Settings',
	settings_group_tab: 'Group',
	settings_group_unassigned: 'Unassigned users',
	settings_group_unassigned_empty: 'All users are assigned to this group',
	settings_groups_section_description: 'Manage user groups and structure responsibilities.',
	settings_groups_tab: 'Usergroups',
	settings_help_section_description: 'Reach help topics and support quickly.',
	settings_help_tab: 'Help',
	settings_language_caption: 'App language – German, English or follow the system setting',
	settings_language_label: 'Language',
	settings_language_option_system: 'Follow system language',
	settings_layout_bottom_left_main_toolbar_slot_label: 'Bottom left',
	settings_layout_bottom_right_main_toolbar_slot_label: 'Bottom right',
	settings_layout_configurable_layout_slot_buttons_avatar_description:
		"The custom user's profile picture and instance selection",
	settings_layout_configurable_layout_slot_buttons_avatar_label: 'Profile picture',
	settings_layout_configurable_layout_slot_buttons_contact_information_description:
		'Opens the contact information search',
	settings_layout_configurable_layout_slot_buttons_contact_information_label: 'Contact',
	settings_layout_configurable_layout_slot_buttons_create_description: 'Menu to create new activities',
	settings_layout_configurable_layout_slot_buttons_create_label: 'New',
	settings_layout_configurable_layout_slot_buttons_idos_description: 'Overview of file instances',
	settings_layout_configurable_layout_slot_buttons_idos_label: 'Files',
	settings_layout_configurable_layout_slot_buttons_loading_indicator_description:
		'An indicator that shows the current module and loading activity',
	settings_layout_configurable_layout_slot_buttons_loading_indicator_label: 'Indicator',
	settings_layout_configurable_layout_slot_buttons_menu_description: 'The menu to navigate between modules',
	settings_layout_configurable_layout_slot_buttons_menu_label: 'Menu',
	settings_layout_configurable_layout_slot_buttons_none_description: 'Do not use this slot',
	settings_layout_configurable_layout_slot_buttons_none_label: 'Do not use slot',
	settings_layout_configurable_layout_slot_buttons_search_description: 'Opens the search dialog',
	settings_layout_configurable_layout_slot_buttons_search_label: 'Search',
	settings_layout_configurable_layout_slot_buttons_settings_description: 'The settings module',
	settings_layout_configurable_layout_slot_buttons_settings_label: 'Settings',
	settings_layout_configurable_layout_slot_buttons_timer_description: 'Opens your Timer list',
	settings_layout_configurable_layout_slot_buttons_timer_label: 'Timer',
	settings_layout_configurable_layout_slot_buttons_user_online_description: 'The user online list',
	settings_layout_configurable_layout_slot_buttons_user_online_label: 'User online',
	settings_layout_description: 'Where should the list of logged-in users be displayed?',
	settings_layout_description_small_device: 'What elements should be in the top bar and in the menu at the bottom?',
	settings_layout_group_mobile_bottom_bar: 'Bottom Bar',
	settings_layout_group_mobile_top_bar: 'Top Bar',
	settings_layout_group_modules: 'Modules',
	settings_layout_group_navigation: 'Navigation',
	settings_layout_group_user_list: 'User List',
	settings_layout_group_work_mode: 'Work Mode',
	settings_layout_mobile_section_description: 'Configure mobile toolbar slots and smartphone controls.',
	settings_layout_navigation_mode_caption:
		'Choose whether navigation is displayed as a sidebar or top bar in the header',
	settings_layout_navigation_mode_label: 'Navigation mode',
	settings_layout_navigation_mode_sidebar: 'Sidebar',
	settings_layout_navigation_mode_topbar: 'Top Bar',
	settings_layout_section_description: 'Control desktop layout, drawers and workspace visibility.',
	settings_layout_tab: 'Layout',
	settings_layout_timer_enabled_caption: 'Shows or hides the timer in the header and menus',
	settings_layout_timer_enabled_label: 'Enable timer',
	settings_layout_top_left_main_toolbar_slot_first_label: 'Top left 1',
	settings_layout_top_left_main_toolbar_slot_second_label: 'Top left 2',
	settings_layout_top_right_main_toolbar_slot_first_label: 'Top right 1',
	settings_layout_top_right_main_toolbar_slot_second_label: 'Top right 2',
	settings_layout_user_online_position_label: 'User list position',
	settings_layout_user_online_position_left: 'Left',
	settings_layout_user_online_position_off: 'Off',
	settings_layout_user_online_position_right: 'Right',
	settings_layout_user_show_offline_users: 'Also show offline users',
	settings_list_avatar_toggle_infobar_module: 'Infobar module',
	settings_list_avatar_toggle_label: 'Profile picture',
	settings_list_avatar_toggle_mode_avatar: 'Profile picture (person)',
	settings_list_avatar_toggle_mode_module: 'Profile picture (module)',
	settings_list_grouping_toggle_mode_module: 'Module',
	settings_list_grouping_toggle_mode_none: 'No grouping',
	settings_list_grouping_toggle_mode_timeframe: 'Timeframe',
	settings_list_preview_linked_idos: 'Linked files',
	settings_list_preview_title: 'Title',
	settings_lists_column_apply_all: 'Apply to all modules',
	settings_lists_column_apply_all_confirm_message: 'Apply the column configuration of “{module}” to all modules?',
	settings_lists_column_apply_all_success: 'Column configuration applied to all modules',
	settings_lists_column_header_drag_hint:
		'Tip: you can also reorder columns by dragging the column headers directly in the list.',

	settings_lists_column_hidden_heading: 'Hidden',
	settings_lists_column_modified_indicator: 'Customized',

	settings_lists_column_module_label: 'Module',
	settings_lists_column_order_hint: 'Top = left in the list',

	settings_lists_column_preview_label: 'Preview – what the list looks like',

	settings_lists_column_reset: 'Reset',

	settings_lists_column_reset_success: 'Column configuration of “{module}” reset',
	settings_lists_column_shown_heading: 'Shown columns',
	settings_lists_description: 'How should a row be displayed in the modules?',
	settings_lists_extended: 'Extended',
	settings_lists_group_column_order: 'Column Order',
	settings_lists_group_grouping: 'Grouping',
	settings_lists_group_preview: 'Preview',
	settings_lists_grouping_description: 'How should the rows of the inbox be grouped?',
	settings_lists_module_record_history: 'Record history',
	settings_lists_preview_description: 'Preview',
	settings_lists_section_description: 'Define list layout, preview and grouping behavior.',
	settings_lists_tab: 'Lists',
	settings_logout_button_label: 'Logout',
	settings_mail_auto_delegate_section_description: 'Configure automatic delegation rules for incoming emails.',
	settings_mail_auto_delegate_tab: 'Auto Delegation',

	settings_mail_blacklist_section_description: 'Permanently block senders and manage the blacklist.',
	settings_mail_blacklist_tab: 'Blacklist',

	settings_mail_no_archive_section_description: 'Define addresses to hide.',
	settings_mail_no_archive_tab: 'Hidden Addresses',
	settings_mail_remove_spam_section_description: 'Define rules to automatically remove the spam marking.',

	settings_mail_remove_spam_tab: 'Remove Spam Marking',
	settings_mail_signatures_section_description: 'Manage personal signatures, placeholder data and global signatures.',
	settings_mail_signatures_tab: 'Signatures',

	settings_mail_spam_section_description: 'Create and manage spam detection rules.',
	settings_mail_spam_tab: 'Spam Rules',

	settings_menu_description: 'In which order would you like to display your menu items?',
	settings_menu_group_order: 'Order',
	settings_menu_inverse_caption:
		'The bottom bar menu opens upward - sorted in reverse, the first entries sit right above your thumb.',

	settings_menu_inverse_label: 'Sort the bottom bar menu in reverse order',
	settings_menu_section_description: 'Adjust menu order and navigation behavior.',

	settings_menu_tab: 'Menu',
	settings_mobile_recents_label: 'Recently used',
	settings_navigation_title: 'Settings',
	settings_new_theme_label: 'New Theme',
	settings_notifications_appointment: 'Appointments',
	settings_notifications_description:
		'Here you can configure for which activities you want to receive push notifications.',
	settings_notifications_documents: 'Documents',
	settings_notifications_group_calendar: 'Calendar',
	settings_notifications_group_email: 'Email',
	settings_notifications_group_push: 'Push',
	settings_notifications_ido: 'Records',
	settings_notifications_ido_subscriptions_add: 'Add',
	settings_notifications_ido_subscriptions_all_instances: 'All my instances',
	settings_notifications_ido_subscriptions_any_user: 'Anyone',
	settings_notifications_ido_subscriptions_caption:
		'Choose which instances and which editor trigger a notification when a record is saved.',
	settings_notifications_ido_subscriptions_empty: 'No record notifications configured yet.',
	settings_notifications_ido_subscriptions_instance_placeholder: 'Select instance',
	settings_notifications_ido_subscriptions_remove: 'Remove',
	settings_notifications_ido_subscriptions_user_placeholder: 'Select editor',
	settings_notifications_load_error_retry: 'Try again',
	settings_notifications_load_error_text:
		'The notification settings are currently unavailable. Check your connection and try again.',
	settings_notifications_load_error_title: 'Notifications could not be loaded',
	settings_notifications_mail: 'Mails',
	settings_notifications_message: 'Messages',
	settings_notifications_modules_group: 'Modules',
	settings_notifications_notes: 'Notes',
	settings_notifications_phone_calls: 'Phone calls',
	settings_notifications_section_description: 'Manage push notifications for modules and activities.',
	settings_notifications_tab: 'Notifications',
	settings_notifications_tasks: 'Tasks',
	settings_page_subtitle:
		'Categories, keywords and quick jumps help you reach the right setting instantly, even on smaller screens.',
	settings_page_title: 'Settings at a glance',
	settings_performance_caching_toggle_label: 'Performance Caching',
	settings_personal_access_tokens_acquisition_manual_pat: 'Manual token',
	settings_personal_access_tokens_acquisition_oauth: 'Connected app',
	settings_personal_access_tokens_admin_column_revocation_reason: 'Revocation reason',
	settings_personal_access_tokens_admin_column_revoked_by: 'Revoked by',
	settings_personal_access_tokens_admin_column_user: 'User',
	settings_personal_access_tokens_admin_empty: 'No access grants are available for administration.',
	settings_personal_access_tokens_admin_loading: 'Loading all access tokens...',
	settings_personal_access_tokens_admin_section_description:
		'Audit and revoke personal access tokens issued by users on this instance.',
	settings_personal_access_tokens_admin_section_title: 'All personal access tokens',
	settings_personal_access_tokens_column_acquisition_type: 'Access type',
	settings_personal_access_tokens_column_actions: 'Actions',
	settings_personal_access_tokens_column_created_at: 'Created',
	settings_personal_access_tokens_column_expires_at: 'Expires',
	settings_personal_access_tokens_column_last_used_at: 'Last used',
	settings_personal_access_tokens_column_name: 'Name',
	settings_personal_access_tokens_column_scopes: 'Scopes',
	settings_personal_access_tokens_column_status: 'Status',
	settings_personal_access_tokens_connect_button: 'Connect app',
	settings_personal_access_tokens_connect_codex_guidance:
		'Add this MCP address to your OAuth-capable MCP client and start the connection there. Sign-in and granting the required permissions then take place in the infra-struktur-app.',
	settings_personal_access_tokens_connect_copy_button: 'Copy resource',
	settings_personal_access_tokens_connect_copy_error: 'The MCP resource could not be copied.',
	settings_personal_access_tokens_connect_copy_success: 'The MCP resource was copied.',
	settings_personal_access_tokens_connect_dialog_title: 'Connect an app',
	settings_personal_access_tokens_connect_resource: 'MCP resource',
	settings_personal_access_tokens_create_alias_custom_label: 'Custom scopes',
	settings_personal_access_tokens_create_alias_read_only_hint: 'All read scopes for the supported modules.',
	settings_personal_access_tokens_create_alias_read_only_label: 'Read-only',
	settings_personal_access_tokens_create_alias_read_write_hint:
		'All read and write scopes for the supported modules. Includes destructive actions.',
	settings_personal_access_tokens_create_alias_read_write_label: 'Read and write',
	settings_personal_access_tokens_create_button: 'New token',
	settings_personal_access_tokens_create_cancel_label: 'Cancel',
	settings_personal_access_tokens_create_capability_agent_execute: 'Execute agent actions',
	settings_personal_access_tokens_create_capability_alarm_read: 'Read reminders',
	settings_personal_access_tokens_create_capability_calendar_read: 'Read calendar entries',
	settings_personal_access_tokens_create_capability_contact_read: 'Read contacts',
	settings_personal_access_tokens_create_capability_desktop_read: 'Read home screen',
	settings_personal_access_tokens_create_capability_document_read: 'Read document storage',
	settings_personal_access_tokens_create_capability_ido_activity_read: 'Read activities',
	settings_personal_access_tokens_create_capability_ido_activity_write: 'Write activities',
	settings_personal_access_tokens_create_capability_ido_document_read: 'Read documents',
	settings_personal_access_tokens_create_capability_ido_document_write: 'Write documents',
	settings_personal_access_tokens_create_capability_ido_print_execute: 'Execute print actions',
	settings_personal_access_tokens_create_capability_ido_print_read: 'Read print configurations',
	settings_personal_access_tokens_create_capability_ido_read: 'Read files',
	settings_personal_access_tokens_create_capability_ido_write: 'Write files',
	settings_personal_access_tokens_create_capability_kanban_read: 'Read Kanban boards',
	settings_personal_access_tokens_create_capability_kanban_write: 'Write Kanban boards',
	settings_personal_access_tokens_create_capability_mail_read: 'Read mail',
	settings_personal_access_tokens_create_capability_mail_rules_read: 'Read mail rules',
	settings_personal_access_tokens_create_capability_mail_signature_read: 'Read mail signatures',
	settings_personal_access_tokens_create_capability_message_read: 'Read messages',
	settings_personal_access_tokens_create_capability_my_settings_read: 'Read own settings',
	settings_personal_access_tokens_create_capability_note_read: 'Read notes',
	settings_personal_access_tokens_create_capability_notification_read: 'Read notifications',
	settings_personal_access_tokens_create_capability_phonecall_read: 'Read phone calls',
	settings_personal_access_tokens_create_capability_task_read: 'Read tasks',
	settings_personal_access_tokens_create_capability_user_preferences_read: 'Read user preferences',
	settings_personal_access_tokens_create_capability_user_read_self: 'Read own user',
	settings_personal_access_tokens_create_capability_user_state_read: 'Read user state',
	settings_personal_access_tokens_create_clipboard_error_message: 'The token could not be copied to the clipboard.',
	settings_personal_access_tokens_create_clipboard_success_message: 'The token was copied to the clipboard.',
	settings_personal_access_tokens_create_dialog_title: 'Create personal access token',
	settings_personal_access_tokens_create_field_expires_at_hint:
		'Optional. Use a future date to limit the token lifetime.',
	settings_personal_access_tokens_create_field_expires_at_label: 'Expires on',
	settings_personal_access_tokens_create_field_name_hint: 'A short description that helps you recognize the token.',
	settings_personal_access_tokens_create_field_name_label: 'Token name',
	settings_personal_access_tokens_create_field_scopes_hint:
		'Choose a preset or pick the exact capabilities the token may use.',
	settings_personal_access_tokens_create_field_scopes_label: 'Scopes',
	settings_personal_access_tokens_create_submit_label: 'Create token',
	settings_personal_access_tokens_create_success_acknowledge_button: 'I have stored the token',
	settings_personal_access_tokens_create_success_copy_button: 'Copy token',
	settings_personal_access_tokens_create_success_title: 'Your new token',
	settings_personal_access_tokens_create_success_warning_message:
		'This token is shown only once. Store it in a secure place before closing this dialog.',
	settings_personal_access_tokens_details_button: 'Details',
	settings_personal_access_tokens_details_client: 'OAuth client',
	settings_personal_access_tokens_details_dialog_title: 'Access details',
	settings_personal_access_tokens_details_revoked_at: 'Revoked at',
	settings_personal_access_tokens_edit_scopes_button: 'Edit scopes',
	settings_personal_access_tokens_edit_scopes_cancel_label: 'Cancel',
	settings_personal_access_tokens_edit_scopes_dialog_title: 'Edit token scopes',
	settings_personal_access_tokens_edit_scopes_submit_label: 'Save scopes',
	settings_personal_access_tokens_edit_scopes_success_message: 'Token scopes were updated.',
	settings_personal_access_tokens_empty_hint: 'Create a personal access token to grant scoped API access.',
	settings_personal_access_tokens_empty_title: 'No personal access tokens yet',
	settings_personal_access_tokens_error_oauth_reconnect_required:
		'OAuth scopes can only be changed by reconnecting the app.',
	settings_personal_access_tokens_loading: 'Loading access tokens...',
	settings_personal_access_tokens_loading_error: 'The personal access tokens could not be loaded.',
	settings_personal_access_tokens_manual_create_button: 'Create token manually',
	settings_personal_access_tokens_reconnect_button: 'Reconnect',
	settings_personal_access_tokens_reconnect_dialog_intro:
		'Reconnect this app to renew its authorization and confirm the requested scopes.',
	settings_personal_access_tokens_reconnect_dialog_title: 'Reconnect app',
	settings_personal_access_tokens_retry_button: 'Try again',
	settings_personal_access_tokens_revoke_cancel_label: 'Cancel',
	settings_personal_access_tokens_revoke_dialog_message:
		'Revoking this access immediately blocks any further requests using it. This action cannot be undone.',
	settings_personal_access_tokens_revoke_dialog_title: 'Revoke access',
	settings_personal_access_tokens_revoke_field_reason_hint:
		'Optional. The reason is shown to administrators in the audit list.',
	settings_personal_access_tokens_revoke_field_reason_label: 'Reason',
	settings_personal_access_tokens_revoke_submit_label: 'Revoke',
	settings_personal_access_tokens_revoke_success_message: 'Access was revoked.',
	settings_personal_access_tokens_save_error: 'The personal access token could not be saved.',
	settings_personal_access_tokens_scope_unknown: 'Unknown scope',
	settings_personal_access_tokens_search_terms: 'oauth,codex,connect,manual token,mcp,api',
	settings_personal_access_tokens_section_description:
		'Connect apps or manage manually created tokens that grant scoped access to this instance.',
	settings_personal_access_tokens_section_title: 'MCP/API access',
	settings_personal_access_tokens_status_active: 'Active',
	settings_personal_access_tokens_status_expired: 'Expired',
	settings_personal_access_tokens_status_reauthorization_required: 'Reconnect required',
	settings_personal_access_tokens_status_revoked: 'Revoked',
	settings_personal_access_tokens_value_unavailable: 'Not available',
	settings_phone_calllist_name_header: 'Name',
	settings_phone_calllist_standard_header: 'Standard',
	settings_phone_direct_dial_label: 'Extension',
	settings_phone_group_calllists: 'Call Lists',
	settings_phone_group_dial_help: 'Dial Help',
	settings_phone_location_label: 'Location',
	settings_phone_save_button: 'Save',
	settings_phone_section_description: 'Configure dial help and call lists.',
	settings_phone_tab: 'Phone',
	settings_publish_toggle_label: 'Public',
	settings_search_empty_hint: 'Try terms like profile picture, push, layout, calendar or menu.',
	settings_search_empty_title: 'No matching setting found',
	settings_search_placeholder: 'Search',
	settings_search_results: 'Direct matches',

	settings_search_tags_label: 'Search tags',
	settings_share_toggle_label: 'Share',
	settings_shortcuts_section_description: 'Customize keyboard shortcuts for navigation, actions, and the editor.',
	settings_shortcuts_tab: 'Shortcuts',
	settings_start_page_alias_placeholder: 'Alias',
	settings_start_page_alias_search_empty: 'No channels found.',
	settings_start_page_alias_search_placeholder: 'Search channels…',
	settings_start_page_aliases_group_description:
		'Custom display name for the channel. Leave empty to use the original name.',
	settings_start_page_aliases_group_title: 'Channel aliases',
	settings_start_page_channel_tab_document: 'Documents',
	settings_start_page_channel_tab_email: 'Emails',
	settings_start_page_channel_tab_phonecall: 'Calls',
	settings_start_page_channels_empty: 'No channels available.',
	settings_start_page_channels_group_description: 'Only entries from activated channels appear on the home page.',
	settings_start_page_channels_group_title: 'Channel subscriptions',
	settings_start_page_load_error: 'Could not be loaded.',
	settings_start_page_loading: 'Loading…',
	settings_start_page_module_activity: 'File notes',
	settings_start_page_module_activity_caption: 'Due file notes and follow-ups from records.',
	settings_start_page_module_appointment: "Today's appointments",
	settings_start_page_module_appointment_caption: "Your appointments for today's date.",
	settings_start_page_module_document: 'Documents',
	settings_start_page_module_document_caption: 'Unfinished documents from the subscribed shelves.',
	settings_start_page_module_email: 'Emails',
	settings_start_page_module_email_caption: 'Unfinished emails from the subscribed mailboxes.',
	settings_start_page_module_message: 'Messages',
	settings_start_page_module_message_caption: 'Unfinished internal messages.',
	settings_start_page_module_note: 'Notes',
	settings_start_page_module_note_caption: 'Personal sticky notes.',
	settings_start_page_module_phonecall: 'Calls',
	settings_start_page_module_phonecall_caption: 'Unfinished call entries from your call lists.',
	settings_start_page_module_task: 'Tasks',
	settings_start_page_module_task_caption: 'Unfinished tasks.',
	settings_start_page_modules_group_description:
		'Controls which areas appear in the home page list and in which order (drag the handle to sort). The order applies when module grouping is enabled; deactivated areas are hidden completely.',
	settings_start_page_modules_group_title: 'Modules',
	settings_start_page_retry: 'Retry',
	settings_start_page_section_description: 'Choose which modules and channels appear on the home page.',
	settings_start_page_tab: 'Home',
	settings_theme_app_font_size_caption: 'Current size: %value% pt',
	settings_theme_app_font_size_label: 'App font size',
	settings_theme_btn_color_actions: 'Actions button',
	settings_theme_btn_color_attach: 'Attach button',
	settings_theme_btn_color_back: 'Back button',
	settings_theme_btn_color_copy: 'Copy button',
	settings_theme_btn_color_delete: 'Delete button',
	settings_theme_btn_color_edit: 'Edit button',
	settings_theme_btn_color_favorite: 'Favorite button',
	settings_theme_btn_color_fullscreen: 'Fullscreen button',
	settings_theme_btn_color_plan: 'Plan button',
	settings_theme_btn_color_publish: 'Publish button',
	settings_theme_btn_color_reset: 'Reset',
	settings_theme_btn_color_reset_caption: 'Reset all button colors to their default values',
	settings_theme_btn_color_reset_title: 'Restore default colors',
	settings_theme_btn_color_save: 'Save button',
	settings_theme_btn_color_send: 'Send button',
	settings_theme_btn_color_share: 'Share button',
	settings_theme_btn_color_spam: 'Spam button',
	settings_theme_btn_color_unpublish: 'Hide button',
	settings_theme_button_color_mode_multi_caption: 'Each action has its own color',
	settings_theme_button_color_mode_multi_label: 'Multi-color',
	settings_theme_button_color_mode_title: 'Button colors in the side panel',
	settings_theme_button_color_mode_uni_caption: 'Neutral single-color style',
	settings_theme_button_color_mode_uni_label: 'Uniform',
	settings_theme_button_density_compact_caption: 'Icons only (tooltip shows name)',
	settings_theme_button_density_compact_label: 'Compact',
	settings_theme_button_density_full_caption: 'Icon + label',
	settings_theme_button_density_full_label: 'With label',
	settings_theme_button_density_title: 'Button appearance in the side panel',
	settings_theme_cancel_theme: 'Cancel',
	settings_theme_compact_button_view_label: 'Should the buttons have a label?',
	settings_theme_custom_color_label: 'Pick custom color',
	settings_theme_dark_color_label: 'Background color in dark mode',
	settings_theme_dark_model_caption: 'Light, dark or follow system setting',
	settings_theme_dark_model_label: 'Mode',
	settings_theme_delete_theme: 'Delete',
	settings_theme_description: 'Edit the look and feel of your infra-struktur app',
	settings_theme_edit_theme_label: 'Edit Theme',
	settings_theme_group_appearance: 'Appearance',
	settings_theme_group_button_colors: 'Button Colors',
	settings_theme_group_color_scheme: 'Color Scheme',
	settings_theme_group_theme: 'Colors',
	settings_theme_icon_style_regular_caption: 'Thin outline icons',
	settings_theme_icon_style_regular_label: 'Thin',
	settings_theme_icon_style_solid_caption: 'Solid filled icons',
	settings_theme_icon_style_solid_label: 'Solid',
	settings_theme_icon_style_title: 'Icon style',
	settings_theme_multi_color_buttons_label: 'multi color buttons in the side panel',
	settings_theme_primary_color: 'Primary Color',
	settings_theme_primary_color_caption: 'Main color for buttons and active elements',
	settings_theme_primary_color_label: 'Primary color (top bar)',
	settings_theme_save_theme: 'save',
	settings_theme_secondary_color_label: 'Secondary color (second bar)',
	settings_theme_section_description: 'Shape the colors, appearance and visual language of the app.',
	settings_theme_selected_theme_label: 'Selected theme',
	settings_theme_solid_icons: 'Should solid icons be used?',
	settings_theme_surface: 'Surface',
	settings_theme_surface_caption: 'Base tone for backgrounds and surfaces',
	settings_theme_tab: 'Appearance',
	settings_theme_toggle_mode_automatic: 'Automatic',
	settings_theme_toggle_mode_dark: 'Dark',
	settings_theme_toggle_mode_light: 'Light',
	settings_theme_uni_color_buttons_label: 'single color buttons in the side panel',
	settings_theme_uni_color_color_label: 'Color of the uni color buttons',
	settings_theme_uni_color_label: 'Solid color buttons',
	settings_timezone_description: 'Select your time zone or have it determined automatically',
	settings_timezone_selected_automatic_label: 'Automatic',
	settings_timezone_selected_label: 'Time zone',
	settings_user_online_list_view_mode_compressed_label: 'Compressed view',
	settings_user_state_description:
		'Here you can specify the locations where the stay should be displayed in the user online list.',

	settings_user_state_latitude_description: 'Latitude',
	settings_user_state_longitude_description: 'Longitude',
	settings_user_state_radius_description: 'Radius',
	settings_user_state_section_description: 'Manage locations and automatic presence rules.',
	settings_user_state_tab: 'Places',
	settings_widgets_enabled_caption: 'Displays a sidebar with widgets next to the inbox.',
	settings_widgets_enabled_label: 'Show widget sidebar',

	settings_widgets_limit_reached: 'Limit reached — deactivate a widget to add another.',
	settings_widgets_picker_caption: 'Up to 3 widgets can be active at the same time.',
	settings_widgets_picker_title: 'Active Widgets',
	settings_widgets_section_description: 'Configure and select widgets for the inbox sidebar.',
	settings_widgets_tab: 'Widgets',
	shortcuts_action_cheatsheet_toggle: 'Shortcut overview',
	shortcuts_action_contact_open: 'Open Contact',

	shortcuts_action_create_appointment: 'New appointment',
	shortcuts_action_create_mail: 'New email',
	shortcuts_action_create_note: 'New note',
	shortcuts_action_create_phonecall: 'New phone call',
	shortcuts_action_create_task: 'New task',
	shortcuts_action_darkmode_toggle: 'Toggle dark mode',
	shortcuts_action_detail_delete: 'Delete open item',
	shortcuts_action_detail_save: 'Save open item',
	shortcuts_action_detail_share: 'Share open item',
	shortcuts_action_list_favorite_toggle: 'Toggle favorite',
	shortcuts_action_list_item_next: 'Next item',
	shortcuts_action_list_item_prev: 'Previous item',
	shortcuts_action_list_tab_all: 'Tab: All',
	shortcuts_action_list_tab_mine: 'Tab: Mine',
	shortcuts_action_list_tab_open: 'Tab: Open',
	shortcuts_action_mail_create_send: 'Send mail',
	shortcuts_action_mail_create_send_later: 'Send mail later',
	shortcuts_action_mail_forward: 'Forward',
	shortcuts_action_mail_reply: 'Reply',
	shortcuts_action_mail_reply_all: 'Reply all',
	shortcuts_action_mail_spam: 'Mark as spam',
	shortcuts_action_nav_calendar: 'Go to calendar',
	shortcuts_action_nav_documents: 'Go to documents',
	shortcuts_action_nav_inbox: 'Go to inbox',
	shortcuts_action_nav_kanban: 'Go to Kanban board',
	shortcuts_action_nav_mails: 'Go to mails',
	shortcuts_action_nav_messages: 'Go to messages',
	shortcuts_action_nav_notes: 'Go to notes',
	shortcuts_action_nav_phonecalls: 'Go to phone calls',
	shortcuts_action_nav_settings: 'Go to settings',
	shortcuts_action_nav_tasks: 'Go to tasks',
	shortcuts_action_settings_open: 'Open Settings',
	shortcuts_action_sidebar_toggle: 'Toggle sidebar',

	shortcuts_action_spotlight_toggle: 'Open search',
	shortcuts_action_task_delay_day: 'Delay 1 day',

	shortcuts_action_task_delay_week: 'Delay 1 week',

	shortcuts_badge_destructive: 'Destructive',

	shortcuts_cheatsheet_caption: 'All active shortcuts at a glance.',
	shortcuts_cheatsheet_empty: 'No active shortcuts.',
	shortcuts_cheatsheet_open_settings: 'Settings',
	shortcuts_cheatsheet_search_placeholder: 'Search shortcuts...',
	shortcuts_cheatsheet_title: 'Keyboard Shortcuts',
	shortcuts_conflict_banner_caption: 'Multiple actions share the same key combination. Adjust one of them.',
	shortcuts_conflict_banner_title: '{count} conflict(s) detected',

	shortcuts_export_button: 'Export',
	shortcuts_export_caption: 'Save all bindings as a JSON file.',
	shortcuts_export_label: 'Export shortcuts',

	shortcuts_group_bindings: 'Bindings',
	shortcuts_group_data: 'Import / Export',
	shortcuts_group_defaults: 'Reset',
	shortcuts_group_master: 'General',
	shortcuts_import_button: 'Import',

	shortcuts_import_caption: 'Load bindings from a JSON file.',
	shortcuts_import_error: 'Import failed — invalid file',

	shortcuts_import_label: 'Import shortcuts',
	shortcuts_import_success: 'Shortcuts imported',
	shortcuts_master_toggle_caption: 'Master switch — disables all shortcuts at once.',
	shortcuts_master_toggle_label: 'Shortcuts enabled',
	shortcuts_preset_custom: 'Custom',
	shortcuts_recorder_clear: 'Clear',
	shortcuts_recorder_conflict_takeover: 'Remove shortcut from “{other}” and use it here',
	shortcuts_recorder_conflict_warning: 'Conflicts with "{other}". Saving will create a conflict.',
	shortcuts_recorder_escape_hint: 'Esc to clear. Save to apply.',
	shortcuts_recorder_label_for: 'Action:',
	shortcuts_recorder_press_hint: 'Press the desired key combination',
	shortcuts_recorder_reserved_warning: 'This combination is reserved by the system and cannot be used.',

	shortcuts_recorder_save: 'Save',
	shortcuts_recorder_title: 'Record Shortcut',
	shortcuts_reset_applied: 'Shortcuts reset to defaults',
	shortcuts_reset_button: 'Reset',
	shortcuts_reset_caption:
		'Resets all shortcuts to the minimal default set (Spotlight, Settings). Custom changes are lost.',
	shortcuts_reset_confirm_accept: 'Reset',
	shortcuts_reset_confirm_message:
		'All custom changes will be removed. Only Spotlight (⌘K) and Settings (⌘,) stay enabled. This cannot be undone.',
	shortcuts_reset_confirm_title: 'Reset all shortcuts?',
	shortcuts_reset_label: 'Reset to defaults',

	shortcuts_row_conflict_caption: 'Conflict — this key combination is used by multiple actions.',
	shortcuts_row_record_title: 'Record key combination',

	shortcuts_row_reset_title: 'Reset to default',
	shortcuts_row_saved: 'Shortcut saved',
	shortcuts_row_unassigned: 'Unassigned',
	shortcuts_scope_all: 'All',
	shortcuts_scope_detail: 'Detail',
	shortcuts_scope_global: 'Global',
	shortcuts_scope_list: 'Lists',
	shortcuts_scope_navigation: 'Navigation',

	shortcuts_search_empty: 'No shortcuts match your search.',
	shortcuts_search_placeholder: 'Search shortcuts...',
	shortcuts_standard_preset_applied: 'Standard layout applied',
	shortcuts_standard_preset_button: 'Apply',
	shortcuts_standard_preset_caption:
		'Proven layout: G-chord navigation, J/K in lists, save & delete in detail views. Replaces the current layout.',
	shortcuts_standard_preset_confirm_accept: 'Apply',
	shortcuts_standard_preset_confirm_message: 'The standard layout replaces all current shortcuts. Continue?',
	shortcuts_standard_preset_confirm_title: 'Apply standard layout',
	shortcuts_standard_preset_label: 'Standard layout',
	widgets_active_timer_description: 'Currently running time tracker.',
	widgets_active_timer_empty: 'No timer active',
	widgets_active_timer_title: 'Timer',
	widgets_due_tasks_description: 'Tasks that are due today or soon.',
	widgets_due_tasks_empty: 'No due tasks',
	widgets_due_tasks_overdue: 'Overdue',
	widgets_due_tasks_this_week: 'This week',
	widgets_due_tasks_title: 'Due Tasks',
	widgets_due_tasks_today: 'Today',
	widgets_ido_favorites_description: 'Your favorite records.',
	widgets_ido_favorites_drop_success_many: '{count} entries filed into «{title}»',
	widgets_ido_favorites_drop_success_one: 'Filed into «{title}»',
	widgets_ido_favorites_empty: 'No favorites',
	widgets_ido_favorites_show_all: 'Show all ({count})',
	widgets_ido_favorites_show_less: 'Show less',
	widgets_ido_favorites_title: 'Favorites',
	widgets_loading: 'Loading…',
	widgets_mail_stats_description: 'Unfinished entries by module.',
	widgets_mail_stats_title: 'Open Items',
	widgets_pending_alarms_description: 'Upcoming and overdue reminders.',
	widgets_pending_alarms_dismiss: 'Dismiss',
	widgets_pending_alarms_due_now: 'Due now',
	widgets_pending_alarms_empty: 'No pending reminders',
	widgets_pending_alarms_title: 'Reminders',
	widgets_pending_alarms_tomorrow: 'tomorrow',
	widgets_recent_activity_description: 'Your most recently edited entries across all modules.',
	widgets_recent_activity_empty: 'No activity',
	widgets_recent_activity_title: 'Recently Edited',
	widgets_recent_calls_callback: 'Callback requested',
	widgets_recent_calls_description: 'Your latest incoming and outgoing calls.',
	widgets_recent_calls_empty: 'No calls',
	widgets_recent_calls_title: 'Recent Calls',
	widgets_team_status_description: 'Shows who is online and the current status of your colleagues.',
	widgets_team_status_empty: 'No users found',

	widgets_team_status_offline: 'Offline',
	widgets_team_status_title: 'Team Status',
	widgets_today_appointments_description: 'Your appointments for today.',
	widgets_today_appointments_empty: 'No appointments today',
	widgets_today_appointments_title: "Today's Appointments",
};
